export enum InformationCategory {
  Debug = 0,
  Info = 1,
  Warning = 2,
  Error = 3
}
